import { render, staticRenderFns } from "./ConfigBanner.vue?vue&type=template&id=4d3275a8&scoped=true&"
import script from "./ConfigBanner.vue?vue&type=script&lang=js&"
export * from "./ConfigBanner.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBanner.vue?vue&type=style&index=0&id=4d3275a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3275a8",
  null
  
)

export default component.exports